const sunburstdata = {
    "name": "nivo",
    "color": "hsl(306, 70%, 50%)",
    "children": [
        {
            "name": "viz",
            "color": "hsl(234, 70%, 50%)",
            "children": [
                {
                    "name": "stack",
                    "color": "hsl(287, 70%, 50%)",
                    "children": [
                        {
                            "name": "cchart",
                            "color": "hsl(284, 70%, 50%)",
                            "loc": 29452
                        },
                        {
                            "name": "xAxis",
                            "color": "hsl(296, 70%, 50%)",
                            "loc": 88984
                        },
                        {
                            "name": "yAxis",
                            "color": "hsl(313, 70%, 50%)",
                            "loc": 74059
                        },
                        {
                            "name": "layers",
                            "color": "hsl(23, 70%, 50%)",
                            "loc": 129346
                        }
                    ]
                },
                {
                    "name": "ppie",
                    "color": "hsl(299, 70%, 50%)",
                    "children": [
                        {
                            "name": "chart",
                            "color": "hsl(311, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pie",
                                    "color": "hsl(8, 70%, 50%)",
                                    "children": [
                                        {
                                            "name": "outline",
                                            "color": "hsl(217, 70%, 50%)",
                                            "loc": 87248
                                        },
                                        {
                                            "name": "slices",
                                            "color": "hsl(37, 70%, 50%)",
                                            "loc": 93441
                                        },
                                        {
                                            "name": "bbox",
                                            "color": "hsl(100, 70%, 50%)",
                                            "loc": 188716
                                        }
                                    ]
                                },
                                {
                                    "name": "donut",
                                    "color": "hsl(352, 70%, 50%)",
                                    "loc": 146317
                                },
                                {
                                    "name": "gauge",
                                    "color": "hsl(148, 70%, 50%)",
                                    "loc": 97759
                                }
                            ]
                        },
                        {
                            "name": "legends",
                            "color": "hsl(95, 70%, 50%)",
                            "loc": 86121
                        }
                    ]
                }
            ]
        },
        {
            "name": "colors",
            "color": "hsl(58, 70%, 50%)",
            "children": [
                {
                    "name": "rgb",
                    "color": "hsl(342, 70%, 50%)",
                    "loc": 97797
                },
                {
                    "name": "hsl",
                    "color": "hsl(113, 70%, 50%)",
                    "loc": 68257
                }
            ]
        },
        {
            "name": "utils",
            "color": "hsl(41, 70%, 50%)",
            "children": [
                {
                    "name": "randomize",
                    "color": "hsl(11, 70%, 50%)",
                    "loc": 72786
                },
                {
                    "name": "resetClock",
                    "color": "hsl(203, 70%, 50%)",
                    "loc": 119380
                },
                {
                    "name": "noop",
                    "color": "hsl(145, 70%, 50%)",
                    "loc": 107798
                },
                {
                    "name": "tick",
                    "color": "hsl(97, 70%, 50%)",
                    "loc": 39538
                },
                {
                    "name": "forceGC",
                    "color": "hsl(161, 70%, 50%)",
                    "loc": 167674
                },
                {
                    "name": "stackTrace",
                    "color": "hsl(114, 70%, 50%)",
                    "loc": 3118
                },
                {
                    "name": "dbg",
                    "color": "hsl(220, 70%, 50%)",
                    "loc": 118076
                }
            ]
        },
        {
            "name": "generators",
            "color": "hsl(86, 70%, 50%)",
            "children": [
                {
                    "name": "address",
                    "color": "hsl(185, 70%, 50%)",
                    "loc": 140017
                },
                {
                    "name": "city",
                    "color": "hsl(349, 70%, 50%)",
                    "loc": 199952
                },
                {
                    "name": "animal",
                    "color": "hsl(34, 70%, 50%)",
                    "loc": 39745
                },
                {
                    "name": "movie",
                    "color": "hsl(84, 70%, 50%)",
                    "loc": 37738
                },
                {
                    "name": "user",
                    "color": "hsl(215, 70%, 50%)",
                    "loc": 181893
                }
            ]
        },
        {
            "name": "set",
            "color": "hsl(27, 70%, 50%)",
            "children": [
                {
                    "name": "clone",
                    "color": "hsl(335, 70%, 50%)",
                    "loc": 160681
                },
                {
                    "name": "intersect",
                    "color": "hsl(61, 70%, 50%)",
                    "loc": 30203
                },
                {
                    "name": "merge",
                    "color": "hsl(85, 70%, 50%)",
                    "loc": 82095
                },
                {
                    "name": "reverse",
                    "color": "hsl(232, 70%, 50%)",
                    "loc": 129268
                },
                {
                    "name": "toArray",
                    "color": "hsl(343, 70%, 50%)",
                    "loc": 59698
                },
                {
                    "name": "toObject",
                    "color": "hsl(188, 70%, 50%)",
                    "loc": 142699
                },
                {
                    "name": "fromCSV",
                    "color": "hsl(282, 70%, 50%)",
                    "loc": 76427
                },
                {
                    "name": "slice",
                    "color": "hsl(120, 70%, 50%)",
                    "loc": 125751
                },
                {
                    "name": "append",
                    "color": "hsl(58, 70%, 50%)",
                    "loc": 130912
                },
                {
                    "name": "prepend",
                    "color": "hsl(337, 70%, 50%)",
                    "loc": 35931
                },
                {
                    "name": "shuffle",
                    "color": "hsl(62, 70%, 50%)",
                    "loc": 55081
                },
                {
                    "name": "pick",
                    "color": "hsl(240, 70%, 50%)",
                    "loc": 39228
                },
                {
                    "name": "plouc",
                    "color": "hsl(313, 70%, 50%)",
                    "loc": 36465
                }
            ]
        },
        {
            "name": "text",
            "color": "hsl(53, 70%, 50%)",
            "children": [
                {
                    "name": "trim",
                    "color": "hsl(195, 70%, 50%)",
                    "loc": 104510
                },
                {
                    "name": "slugify",
                    "color": "hsl(77, 70%, 50%)",
                    "loc": 15433
                },
                {
                    "name": "snakeCase",
                    "color": "hsl(271, 70%, 50%)",
                    "loc": 74235
                },
                {
                    "name": "camelCase",
                    "color": "hsl(130, 70%, 50%)",
                    "loc": 110749
                },
                {
                    "name": "repeat",
                    "color": "hsl(199, 70%, 50%)",
                    "loc": 190138
                },
                {
                    "name": "padLeft",
                    "color": "hsl(228, 70%, 50%)",
                    "loc": 77005
                },
                {
                    "name": "padRight",
                    "color": "hsl(6, 70%, 50%)",
                    "loc": 76732
                },
                {
                    "name": "sanitize",
                    "color": "hsl(137, 70%, 50%)",
                    "loc": 57105
                },
                {
                    "name": "ploucify",
                    "color": "hsl(200, 70%, 50%)",
                    "loc": 131119
                }
            ]
        },
        {
            "name": "misc",
            "color": "hsl(85, 70%, 50%)",
            "children": [
                {
                    "name": "greetings",
                    "color": "hsl(3, 70%, 50%)",
                    "children": [
                        {
                            "name": "hey",
                            "color": "hsl(174, 70%, 50%)",
                            "loc": 113553
                        },
                        {
                            "name": "HOWDY",
                            "color": "hsl(147, 70%, 50%)",
                            "loc": 44224
                        },
                        {
                            "name": "aloha",
                            "color": "hsl(2, 70%, 50%)",
                            "loc": 164887
                        },
                        {
                            "name": "AHOY",
                            "color": "hsl(325, 70%, 50%)",
                            "loc": 127783
                        }
                    ]
                },
                {
                    "name": "other",
                    "color": "hsl(228, 70%, 50%)",
                    "loc": 130832
                },
                {
                    "name": "path",
                    "color": "hsl(60, 70%, 50%)",
                    "children": [
                        {
                            "name": "pathA",
                            "color": "hsl(150, 70%, 50%)",
                            "loc": 171754
                        },
                        {
                            "name": "pathB",
                            "color": "hsl(40, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pathB1",
                                    "color": "hsl(87, 70%, 50%)",
                                    "loc": 196996
                                },
                                {
                                    "name": "pathB2",
                                    "color": "hsl(27, 70%, 50%)",
                                    "loc": 15038
                                },
                                {
                                    "name": "pathB3",
                                    "color": "hsl(233, 70%, 50%)",
                                    "loc": 139884
                                },
                                {
                                    "name": "pathB4",
                                    "color": "hsl(270, 70%, 50%)",
                                    "loc": 32213
                                }
                            ]
                        },
                        {
                            "name": "pathC",
                            "color": "hsl(341, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pathC1",
                                    "color": "hsl(64, 70%, 50%)",
                                    "loc": 34438
                                },
                                {
                                    "name": "pathC2",
                                    "color": "hsl(294, 70%, 50%)",
                                    "loc": 178266
                                },
                                {
                                    "name": "pathC3",
                                    "color": "hsl(88, 70%, 50%)",
                                    "loc": 66441
                                },
                                {
                                    "name": "pathC4",
                                    "color": "hsl(26, 70%, 50%)",
                                    "loc": 74489
                                },
                                {
                                    "name": "pathC5",
                                    "color": "hsl(321, 70%, 50%)",
                                    "loc": 138246
                                },
                                {
                                    "name": "pathC6",
                                    "color": "hsl(53, 70%, 50%)",
                                    "loc": 180551
                                },
                                {
                                    "name": "pathC7",
                                    "color": "hsl(321, 70%, 50%)",
                                    "loc": 15310
                                },
                                {
                                    "name": "pathC8",
                                    "color": "hsl(62, 70%, 50%)",
                                    "loc": 103911
                                },
                                {
                                    "name": "pathC9",
                                    "color": "hsl(214, 70%, 50%)",
                                    "loc": 106660
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}
export default sunburstdata;